import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Newspaper } from 'lucide-react';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto bg-gradient-to-br from-brand-500 via-brand-700 to-brand-900 text-brand-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 gap-8 py-12 md:grid-cols-3">
          {/* Column 1: Logo and Description */}
          <div className="flex flex-col items-center">
            <Newspaper
              className="mb-3 text-brand-50"
              size={40}
              strokeWidth={1.5}
              aria-hidden
            />
            <h2 className="mb-4 text-center text-2xl font-bold text-brand-50">MedIntel</h2>
            <div className="mx-auto w-full max-w-sm">
              <p className="text-center text-brand-50/95 leading-relaxed">
                Your trusted source for medicine updates, medical news, diabetes research, and endocrinology updates.
                Advancing healthcare through knowledge.
              </p>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="flex flex-col items-center text-center">
            <h3 className="text-lg font-semibold text-brand-50 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-brand-50 hover:text-brand-100 transition">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-brand-50 hover:text-brand-100 transition">About Us</Link>
              </li>
              <li>
                <Link to="/articles" className="text-brand-50 hover:text-brand-100 transition">Articles</Link>
              </li>
              <li>
                <Link to="/chief-editor" className="text-brand-50 hover:text-brand-100 transition">Chief Editor</Link>
              </li>
              <li>
                <Link to="/contact" className="text-brand-50 hover:text-brand-100 transition">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Email and Address */}
          <div className="flex flex-col items-center text-center">
            <h3 className="text-lg font-semibold text-brand-50 mb-4">Contact Info</h3>
            <div className="inline-grid grid-cols-[auto_1fr] items-center gap-x-3 gap-y-3 text-left">
              <Mail size={18} className="text-brand-50 shrink-0" />
              <span className="text-brand-50">info@MedIntel.com</span>
              <MapPin size={18} className="text-brand-50 shrink-0" />
              <span className="text-brand-50 leading-snug">
                <span className="block">Mumbai, Maharashtra, India  </span>
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-brand-50/25 py-5">
          <p className="text-center text-sm text-brand-50/90">
            © {year},{' '}
            <a
              href="https://100billiontech.com/ownership"
              className="hover:text-brand-100 transition"
              target="_blank"
              rel="noopener noreferrer"
            >
              Copy-rights reserved
            </a>
            . Designed by{' '}
            <a
              href="https://100billiontech.com/"
              className="hover:text-brand-100 transition"
              target="_blank"
              rel="noopener noreferrer"
            >
              100billion Tech
            </a>
            .
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
